import { useState, useEffect, useRef } from 'react';
import ExpDataExcel from './ExpDataExcel';
import TotalizaResultados from './TotalizaResultados';
import GraficoBarResultados from './GraficoBarResultados';
import { getgraphicshist, getparamsgraphics } from '../../../services/graphics';
import { ErrorContext } from '../../../utils/context/error';
import IconM from '../../dashboard/menu/icons/Icon';
import FilterModal from './filtermodal';

const InformeHistorico = () => 
  {
     const [resultados, setResultados] = useState([]);
     const [AreaFId, setAreaFId] = useState(0);

     const [totales, setTotales] = useState({});
     const [totalPorAtender, setTotalPorAtender] = useState(0);
     const [totalAtendidos, setTotalAtendidos] = useState(0);
     const [totalDia, setTotalDia] = useState(0);
     const [showM, setShowM] = useState(false);   
     const { setShowToast, setOpciones } = ErrorContext();
     let NombreArea = useRef("");
     
     //--------------------------------------------------
     const realizarConsulta = async (AreaId, fechaIni, horaIni) => 
      {
         const PeriodoId = formatPeriodoId(fechaIni);
         const response = await getgraphicshist(AreaId, PeriodoId, fechaIni, horaIni);
         if (response)                                         
          {
             if (response.status === 200) 
              {
                 setResultados(response.data.data);
                 NombreArea.current = response.data.area[0].NombreArea; 
              }
             else 
             {
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
             }
          }
          setShowToast(false);
      };
     
     //--------------------------------------------------
     useEffect(() => 
      {
         const calcularTotales = () => 
          {
            const newTotales = {};
            resultados.forEach((resultado) => 
              {
                 const { NombreServ, fechaatn } = resultado;
                 const estado = fechaatn ? 'Atendidos' : 'Por Atender';

                 if (!newTotales[NombreServ]) 
                  {
                     newTotales[NombreServ] = 
                     {
                        descripcion: resultado.descripcion,
                        'Por Atender': 0,
                        Atendidos: 0,
                     };
                  }
                 newTotales[NombreServ][estado]++;
              });
             const newTotalPorAtender = Object.values(newTotales).reduce(
             (total, value) => total + value['Por Atender'], 0);

             const newTotalAtendidos = Object.values(newTotales).reduce(
             (total, value) => total + value['Atendidos'], 0);
        
             const newTotalDia = newTotalPorAtender + newTotalAtendidos;
             setTotales(newTotales);
             setTotalPorAtender(newTotalPorAtender);
             setTotalAtendidos(newTotalAtendidos);
             setTotalDia(newTotalDia);
          };
          calcularTotales();
      }, [resultados]);
 
      //-------------------------------------------------
      useEffect(() => 
        {
          const fillInicioGrafica = async() => 
            {
               const response = await getparamsgraphics();
               if (response) 
                {
                   if (response.status === 200) 
                    {
                       setAreaFId(response.data.area[0].AreaId);
                       NombreArea.current = response.data.area[0].NombreArea; 
                    }
                  else
                   {
                     const Mensaje = response.message;
                     const opc = { type: "Danger", message: Mensaje, active: true };
                     setOpciones(opc);
                     setShowToast(true);
                   }
                }
            }
           fillInicioGrafica();
        }, []);
      
      //-------------------------------------------------
      const formatPeriodoId = (date) => 
        {
           const formattedDate = new Date(date);
           const year = formattedDate.getUTCFullYear();
           const month = String(formattedDate.getUTCMonth() + 1).padStart(2, '0');
           const day = String(formattedDate.getUTCDate()).padStart(2, '0');
           return `${year}${month}${day}`;
       };
      
      //------------------------------------------------- 
      const handleFiltrar = () =>
        {
           setShowM(true);
        }

  return (
    <>
      <div className="">
         <div className="paneltitle">
           <label className="text-[1.0rem] font-light text-gray-400 leading-none">Informes/Histórico por Día y Hora</label>
         </div>
         <div className="panelmenu">
            <button className="btnmenu" onClick={() => handleFiltrar()} >
              <IconM svg="filter" className="iconmenu" title="newfile" />
              <span>Filtrar</span>
            </button>

            <button className="btnmenu" id="Eliminar" onClick={() => ExpDataExcel({ resultados })}>
              <IconM svg="fileexcel" className="iconmenu" title="delfile" />
              <span>Exportar</span>
            </button>
         </div>
         <div className="flex w-full md:m-4 text-[1.0rem] font-light text-gray-400 leading-none text-center items-center justify-center">Informe Histórico de Servicios Atendidos para el area de {NombreArea.current}</div>
         <div className='flex flex-col md:flex-row w-full h-full mt-4'> 
           <div className='flex md:flex-1 w-[100%] h-full items-center justify-center md:px-4'>
              <TotalizaResultados
                 totales={totales}
                 totalPorAtender={totalPorAtender}
                 totalAtendidos={totalAtendidos}
                 totalDia={totalDia}
              />

           </div>
           <div className='flex md:flex-1 w-[100%] h-full items-center justify-center md:px-4'>
              <GraficoBarResultados resultados={resultados} />
           </div>
         </div>
      </div>
      {showM && (  
        <FilterModal
          show={showM}
          setShowM={setShowM}
          AreaI={AreaFId}
          realizarConsulta={realizarConsulta}
        ></FilterModal>)
      }
    </>
  );
};

export default InformeHistorico;
